var d=Object.defineProperty;var e=(c,a)=>{for(var b in a)d(c,b,{get:a[b],enumerable:!0})};export{e as a};
//# sourceMappingURL=chunk-HZWWJL43.mjs.map